import AccordionView from './accordion-view'

export default AccordionView
